import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const DesktopNav = ({
  navItems,
  serviciosSubItems,
  isActive,
  serviciosOpen,
  setServiciosOpen,
  serviciosRef,
}) => (
  <nav className="hidden md:flex items-center space-x-1">
    {navItems.map((item) => {
      if (item.hasDropdown) {
        return (
          <div
            key={item.id}
            ref={serviciosRef}
            className="relative"
            onMouseEnter={() => setServiciosOpen(true)}
            onMouseLeave={() => setServiciosOpen(false)}
          >
            <Link
              to={item.path}
              data-testid={`nav-${item.id}`}
              data-analytics-click={`nav-${item.id}`}
              className={`relative inline-flex items-center gap-1 px-4 py-2 rounded-lg font-medium transition-all duration-300 ${
                isActive(item.path)
                  ? 'text-orange-500'
                  : 'text-gray-700 hover:text-orange-500 hover:bg-gray-100'
              }`}
              aria-haspopup="true"
              aria-expanded={serviciosOpen}
            >
              {item.label}
              <ChevronDown
                className={`w-4 h-4 transition-transform duration-300 ${
                  serviciosOpen ? 'rotate-180' : ''
                }`}
              />
              {isActive(item.path) && (
                <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-0.5 bg-orange-500 rounded-full" />
              )}
            </Link>

            {/* Dropdown - transparent glass background */}
            <div
              data-testid="servicios-dropdown"
              className={`absolute left-1/2 -translate-x-1/2 top-full mt-2 w-64 transition-all duration-200 origin-top ${
                serviciosOpen
                  ? 'opacity-100 scale-100 pointer-events-auto'
                  : 'opacity-0 scale-95 pointer-events-none'
              }`}
            >
              {/* Hover bridge to prevent gap closing */}
              <div className="absolute -top-2 left-0 right-0 h-2" />

              <div className="bg-white/40 backdrop-blur-xl border border-white/30 rounded-2xl shadow-2xl overflow-hidden ring-1 ring-black/5">
                <ul className="py-2">
                  {serviciosSubItems.map((sub) => (
                    <li key={sub.id}>
                      <Link
                        to={sub.path}
                        data-testid={`nav-${sub.id}`}
                        data-analytics-click={`nav-${sub.id}`}
                        onClick={() => setServiciosOpen(false)}
                        className={`block px-5 py-2.5 text-sm font-medium transition-all duration-200 ${
                          isActive(sub.path)
                            ? 'text-orange-500 bg-orange-500/10'
                            : 'text-gray-800 hover:text-orange-500 hover:bg-white/50'
                        }`}
                      >
                        {sub.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      }

      return (
        <Link
          key={item.id}
          to={item.path}
          data-testid={`nav-${item.id}`}
          data-analytics-click={`nav-${item.id}`}
          className={`relative px-4 py-2 rounded-lg font-medium transition-all duration-300 ${
            isActive(item.path)
              ? 'text-orange-500'
              : 'text-gray-700 hover:text-orange-500 hover:bg-gray-100'
          }`}
        >
          {item.label}
          {isActive(item.path) && (
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-0.5 bg-orange-500 rounded-full" />
          )}
        </Link>
      );
    })}
  </nav>
);

export default DesktopNav;
